module.exports = __webpack_public_path__ + "static/media/table_column_checkbox_sample_1_demo.1580aa6f.png";